module.exports = __webpack_public_path__ + "static/img/090.158fc31.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/090.png
// module id = bl3c
// module chunks = 0